import Vue from 'vue'
import Router from 'vue-router'
// import { AppointmentWizardRoutes } from '../appointment-wizard/utils/AppointmentWizardRoutes'
import { Routes } from '../order-wizard/utils/Routes'
// import AppointmentWizard from '../appointment-wizard/AppointmentWizard'
import OrderWizard from '../order-wizard/OrderWizard'
// import ClientArea from '../clientarea/ClientArea'

Vue.use(Router)

const disabledRoute = (to, from, next) => { next() }

export const fleetwareUIRouter = (i18n, orderWizardStore) => {
  const sharedRouter = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (to) {
      return { x: 0, y: 0 }
    },
    routes: [
      {
        path: Routes.INVOICE.path,
        name: Routes.INVOICE.name,
        component: () => import(/* webpackChunkName: "INVOICE" */ '@/invoice/pages/InvoicePage.vue'),
        meta: {
          titleKey: 'titles.invoice'
        }
      },
      /* {
        path: '/fizetesdemo',
        name: 'fizetesdemo',
        component: () => import('@/order-wizard/pages/DemoPaymentPage.vue')
      }, */
      {
        path: '/',
        redirect: Routes.defaultPackageSelector(),
        component: OrderWizard,
        children: [
          {
            path: Routes.PACKAGE_SELECTOR.path,
            name: Routes.PACKAGE_SELECTOR.name,
            component: () => import(/* webpackChunkName: "PACKAGE_SELECTOR" */ '@/order-wizard/pages/PackageSelector.vue'),
            meta: {
              titleKey: 'titles.package_selector.{{groupCode}}',
              descriptionKey: 'meta_descriptions.selector.{{groupCode}}'
            }
          },
          {
            path: Routes.VEHICLE_REGISTRATION.path,
            name: Routes.VEHICLE_REGISTRATION.name,
            component: () => import(/* webpackChunkName: "VEHICLE_REGISTRATION" */ '@/order-wizard/pages/RegisterVehicles.vue'),
            meta: {
              titleKey: 'titles.vehicle_registration',
              descriptionKey: 'meta_descriptions.registration'
            },
            beforeEnter: (to, from, next) => {
              orderWizardStore.getters.isCartEmpty() ? next(Routes.defaultPackageSelector()) : next()
            }
          },
          {
            path: Routes.CONTRACT_INPUT.path,
            name: Routes.CONTRACT_INPUT.name,
            component: () => import(/* webpackChunkName: "CONTRACT_INPUT" */ '@/order-wizard/pages/ContractInput.vue'),
            meta: {
              titleKey: 'titles.contract_inputs',
              descriptionKey: 'meta_descriptions.contract_input'
            },
            beforeEnter: (to, from, next) => {
              orderWizardStore.getters.isCartEmpty() ? next(Routes.VEHICLE_REGISTRATION) : next()
            }
          },
          {
            path: Routes.PAYMENT.path,
            name: Routes.PAYMENT.name,
            component: () => import(/* webpackChunkName: "PAYMENT" */ '@/order-wizard/pages/Payment.vue'),
            meta: {
              titleKey: 'titles.payment',
              descriptionKey: 'meta_descriptions.payment'
            },
            beforeEnter: (to, from, next) => {
              (orderWizardStore.getters.isCartEmpty() || !orderWizardStore.state.contractData.isValid()) ? next(Routes.CONTRACT_INPUT) : next()
            }
          },
          {
            path: Routes.THANK_YOU_BANKCARD.path,
            name: Routes.THANK_YOU_BANKCARD.name,
            component: () => import(/* webpackChunkName: "THANK_YOU_BANKCARD" */ '@/order-wizard/pages/ThanksBankCard.vue'),
            meta: {
              titleKey: 'titles.thanks.bankcard',
              descriptionKey: 'meta_descriptions.thank_you_bankcard'
            }
          },
          {
            path: Routes.THANK_YOU_WIRE.path,
            name: Routes.THANK_YOU_WIRE.name,
            component: () => import(/* webpackChunkName: "THANK_YOU_WIRE" */ '@/order-wizard/pages/ThanksWire.vue'),
            meta: {
              titleKey: 'titles.thanks.wire',
              descriptionKey: 'meta_descriptions.thank_you_wire'
            }
          },
          {
            path: Routes.PAYMENT_FAILED.path,
            name: Routes.PAYMENT_FAILED.name,
            component: () => import(/* webpackChunkName: "PAYMENT_FAILED" */ '@/order-wizard/pages/PaymentFailed.vue'),
            props: true,
            meta: {
              titleKey: 'titles.payment_failed',
              descriptionKey: 'meta_descriptions.payment_failed'
            }
          }
        ]
      },
      {
        path: Routes.SIMPLE_PAY_PAYMENT_RESULT.path,
        name: Routes.SIMPLE_PAY_PAYMENT_RESULT.name,
        component: () => import(/* webpackChunkName: "SIMPLE_PAY_PAYMENT_RESULT" */ '@/order-wizard/pages/SimplePayPaymentResult.vue')
      },
      /*{
        path: '/example',
        name: 'example',
        component: () => import('@/order-wizard/pages/ExamplePage.vue')
      },
      {
        path: Routes.LOGIN.path,
        name: Routes.LOGIN.name,
        beforeEnter: disabledRoute,
        component: () => import('@/auth/pages/Login.vue')
      },
      {
        path: '/elfelejtett_jelszo',
        name: 'forgottenpassword',
        beforeEnter: disabledRoute,
        component: () => import('@/auth/pages/ForgottenPassword.vue')
      },
      {
        path: '/idopontfoglalas',
        component: AppointmentWizard,
        beforeEnter: disabledRoute,
        children: [
          {
            path: '/',
            name: 'appointment',
            component: () => import('@/appointment-wizard/pages/Appointment.vue')
          },
          {
            path: AppointmentWizardRoutes.THANKS,
            name: 'thanks_appointment',
            component: () => import('@/appointment-wizard/pages/Thanks.vue')
          }
        ]
      },
      {
        path: '/',
        name: 'clientarea',
        component: ClientArea,
        beforeEnter: disabledRoute,
        children: [
          {
            path: '/profilom',
            name: 'profile',
            component: () => import('@/clientarea/pages/ClientHome.vue')
          },
          {
            path: '/szolgaltatasaim',
            name: 'clientservices',
            component: () => import('@/clientarea/pages/ClientServices.vue')
          },
          {
            path: '/szamlaim',
            name: 'clientinvoices',
            component: () => import('@/clientarea/pages/ClientInvoices.vue')
          },
          {
            path: '/adataim',
            name: 'clientdata',
            component: () => import('@/clientarea/pages/ClientData.vue')
          },
          {
            path: '/jelszo_valtoztatas',
            name: 'clientpasswordchange',
            component: () => import('@/clientarea/pages/ClientPasswordChange.vue')
          }
        ]
      }, */
      {
        path: '*',
        redirect: '/'
      }
    ]
  })

  sharedRouter.beforeEach((to, from, next) => {
    document.getElementsByTagName('title')[0].innerText = translateByKey(to.meta.titleKey, to)
    document.querySelector('meta[name=description]').setAttribute('content', translateByKey(to.meta.descriptionKey, to))
    next(vm => {
      vm.fromRoute = from
    })
  })

  const translateByKey = (key, to) => {
    return i18n.t(`${key ? key.replace(/\{\{(.*?)\}\}/g, (m, prop) => { return to.params[prop] }) : ''}`)
  }

  return sharedRouter
}
